const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const noStore = { cache: 'no-store' };

export async function getMember(id) {
  const res = await fetch(`${API_BASE}/members/${id}`, noStore);
  if (!res.ok) throw new Error('Failed to fetch member');
  return res.json();
}

export async function getMemberByToken(token) {
  const res = await fetch(`${API_BASE}/eform-tokens/${encodeURIComponent(token)}`, noStore);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const message = err.error || 'Failed to fetch member';
    const error = new Error(message);
    error.status = res.status;
    error.isExpired = res.status === 410;
    throw error;
  }
  return res.json();
}

export async function getMemberInvolvements(memberId, params = {}) {
  const searchParams = new URLSearchParams();
  if (params.pageSize) searchParams.set('pageSize', params.pageSize);
  if (params.sortBy) searchParams.set('sortBy', params.sortBy);
  if (params.sortOrder) searchParams.set('sortOrder', params.sortOrder);
  const qs = searchParams.toString();
  const res = await fetch(`${API_BASE}/members/${memberId}/preferences${qs ? `?${qs}` : ''}`, noStore);
  if (!res.ok) throw new Error('Failed to fetch involvements');
  return res.json();
}

export async function getMinistries() {
  const res = await fetch(`${API_BASE}/ministries`, noStore);
  if (!res.ok) throw new Error('Failed to fetch ministries');
  return res.json();
}

export async function getMinistryAreasByGender(gender) {
  const endpoint = gender === 'female' ? 'female' : 'male';
  const res = await fetch(`${API_BASE}/ministry-areas/${endpoint}`, noStore);
  if (!res.ok) throw new Error('Failed to fetch ministry areas');
  return res.json();
}

export async function updateMember(memberId, data) {
  const res = await fetch(`${API_BASE}/members/${memberId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to update member');
  }
  return res.json();
}

export async function submitMinistryInvolvements(memberId, ministryId, data) {
  const res = await fetch(`${API_BASE}/members/${memberId}/ministries/${ministryId}/preferences`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.message || 'Failed to submit involvements');
  }
  return res.json();
}
